import React from 'react';
import { ModuleBridge, TopActionBar, Button, Flex } from '../components';

export const RecoveryDrPolicies = () => {
    return (
        <>
            <TopActionBar>
                <Flex gap="small">
                    <Button type="primary" onClick={() => window.editDRPolicy()}>
                        Add DR Policy
                    </Button>
                </Flex>
            </TopActionBar>
            <div id="recovery_dr_policies_container"></div>
            <ModuleBridge moduleId="recovery_dr_policies" />
        </>
    );
};
